// extracted by mini-css-extract-plugin
export default {"white":"#fff","primary":"#37373b","black":"#000","green":"#00b67a","greenDark":"#007d6c","red":"#f56b6b"};